<div
    [ngClass]="containerClass()"
    [class]="styleClass"
    [ngStyle]="containerStyle()"></div>